import React, {useEffect, useState, useRef, useContext} from "react";
import AmChartPie from '../../../components/AmChartPie';
import SelectionTool from '../../../components/SelectionTool';


export default function RealEstateLeasesByLandlord({onClick}){

	const [chartData, setChartData] = useState([]);
	const [loaded, setLoaded] = useState("false");
	const [selectedCategoryType, setSelectedCategoryType] = useState({});
	
	useEffect(() => {
		loadChartData();
		setLoaded("true");
	}, [loaded]);
	
	const thisContainer = {
		display:"flex",
		width:"calc(100% - 50px)",
		flexDirection:"column",
		alignItems:"center",
		justifyContent:"space-around",
		padding:"10px",
		paddingTop:"0px",
		backgroundColor:"white",
		borderRadius:"6px",
		marginLeft:"20px",
		marginTop:"20px"
	};
	
	const loadChartData = () => {
		let pieData = [
			{label:"British Land", value:Math.round(Math.random()*1000)},
			{label:"BT", value:Math.round(Math.random()*1000)},
			{label:"Sainsbury's", value:Math.round(Math.random()*1000)},
			{label:"Moto Services", value:Math.round(Math.random()*1000)},
			{label:"Crown Estate", value:Math.round(Math.random()*1000)},
			{label:"London Corporation", value:Math.round(Math.random()*1000)}
		];
		
		setChartData(pieData);
		
	};
	
	
	
	const chartProps = {
    fontSize:"14px",
    showScrollbar:false,
    showScrollbarY:false,
    showCursor:true,
    showLegend:false,
    marginLeft:0
	};
	
	const optionValues = [
		{id:"1", name:"Area"},
		{id:"2", name:"Cost"},
		{id:"3", name:"Capacity"}
	];
	
		
	return (
		<div style={thisContainer}>
			
			<AmChartPie
					chartId="realestateleasesbylandlordpie"
					width="100%"
					height="400px"
					chartData={chartData}
					categoryKey="label"
					valueKey="value"
					showLabels="false"
					isDark="true"
					keyPosition="bottom"
					onClick={onClick}
				>
			</AmChartPie>
			<br/><br/><br/>
			<SelectionTool
					title="Showing"
					value="Area"
					values={optionValues}
					dataLoad={loadChartData}
				>
				</SelectionTool>
				
		</div>
		
	);
}